import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { TextField, Checkbox } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CustomRow(_ref) {
  let {
    customDoc,
    isOnEdit,
    onChangeLabel,
    onRemoveCustom,
    onCheckboxChange
  } = _ref;
  const isExistingDoc = isOnEdit && Boolean(customDoc.code);
  const identifier = customDoc.code ?? customDoc.id;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-container space-between mt-2",
    children: [/*#__PURE__*/_jsx(TextField, {
      "data-id": `label-custom-${identifier}`,
      label: I18n.t('project.documents.customPlaceholder'),
      value: customDoc.label,
      onChange: e => onChangeLabel(identifier, e),
      disabled: isExistingDoc
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      "data-id": `delete-custom-${identifier}`,
      className: "small secondary",
      onClick: () => onRemoveCustom(identifier),
      disabled: isExistingDoc,
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "trash"
      })
    }), isExistingDoc && /*#__PURE__*/_jsx(Checkbox, {
      "data-id": `check-custom-${identifier}`,
      onChange: () => onCheckboxChange(customDoc),
      checked: customDoc.requiredInProject
    })]
  }, `row-custom-${identifier}`);
}
CustomRow.defaultProps = {
  isOnEdit: false
};
CustomRow.propTypes = {
  onChangeLabel: PropTypes.func.isRequired,
  onRemoveCustom: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  isOnEdit: PropTypes.bool,
  customDoc: PropTypes.shape({
    code: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    requiredInProject: PropTypes.bool.isRequired
  }).isRequired
};
export default CustomRow;